import { Box, Divider, List, ListItem, Typography } from '@mui/material'
import React from 'react'
import { blue, grey } from '../../../../colors'
import GenericModal from '../../../../components/GenericModal'
import { ButtonType } from '../../../../components/GenericButton/styles'

export interface Summarization {
  label: string
  description: string
  count: number
  comments: string[]
}

interface CommentsSummarizationProps {
  summarization?: Summarization[]
}

const CommentsSummarization: React.FC<CommentsSummarizationProps> = ({ summarization }) => {
  const [selectedSummarization, setSelectedSummarization] = React.useState<Summarization | null>(null)

  if (!summarization || summarization.length === 0) {
    return null
  }

  return (
    <>
      <List sx={{ listStyleType: 'none', pl: 2, mt: -2 }} component="ul" >
        {Array.isArray(summarization) && summarization.map((data) => (
          <ListItem key={data.label} component="li" sx={{ display: 'list-item', mb: -1, color: grey[950] }}>
            <Typography component="span" fontWeight="bold" >
              {data.label}:
            </Typography>
            <Typography component="span" color={grey[850]}> {data.description}</Typography>
            <Typography
              component="span"
              sx={{
                ml: 1,
                whiteSpace: 'nowrap',
                display: { xs: 'block', sm: 'inline' },
                mt: { xs: 0.5, sm: 0 }
              }}
            >
              <Typography
                component="span"
                role="button"
                tabIndex={0}
                aria-label={`View the ${data.count} comments summarized as ${data.label}`}
                sx={{ fontWeight: 500, cursor: 'pointer' }}
                onClick={() => { setSelectedSummarization(data) }}
                onKeyDown={(event: React.KeyboardEvent<HTMLSpanElement>) => {
                  if (event.key === 'Enter' || event.key === ' ') {
                    event.preventDefault()
                    setSelectedSummarization(data)
                  }
                }}
              >
                (<Typography component="span" color={blue[500]} >{data.count} Comments</Typography>)
              </Typography>
            </Typography>
          </ListItem>
        ))}
      </List>
      <Divider sx={{ mt: 4, mb: 8 }} />

      <GenericModal
        destructiveButtonType={ButtonType.Secondary}
        maxWidth='sm'
        isOpen={!!selectedSummarization}
        onClose={() => { setSelectedSummarization(null) }}
        title={selectedSummarization?.label}
        hideConfirmButton>
        <Box sx={{ maxHeight: '70vh', overflowY: 'auto', pr: 1 }}>
          <Typography sx={{ mb: 2, mt: 2, fontStyle: 'italic' }}>{selectedSummarization?.description}</Typography>
          <Box display={'flex'} justifyContent={'space-between'} alignItems="center" pr={2}>
            <Typography sx={{ mb: 2, fontWeight: '600' }}>Comments:</Typography>
          </Box>
          {selectedSummarization && (
            <List sx={{ listStyleType: 'disc', mt: -2 }} component="ul" >
              {selectedSummarization?.comments?.map((comment, idx) => (
                <ListItem key={idx} component="li" sx={{ display: 'list-item', mb: -1, color: grey[950] }}>
                  <Typography component="span">{comment}</Typography>
                </ListItem>
              ))}
            </List>
          )}
        </Box>
        <Divider />
      </GenericModal>
    </>
  )
}

export default CommentsSummarization
